import { Box, Divider, Skeleton, Stack } from '@mui/material'
import type { FC } from 'react'
import type { To } from 'react-router'

import { COLORS, unit } from '@hcr/ui'

import { LayoutNavigationBack } from '../../../common'
import { WeekPreviewLoading } from '../common/weeks-preview'

interface OwnerHoldingDetailsLoadingProps {
  backNavigationPath: To
}

export const OwnerHoldingDetailsLoading: FC<OwnerHoldingDetailsLoadingProps> = ({ backNavigationPath }) => {
  return (
    <LayoutNavigationBack to={backNavigationPath} arrowVariant='outlined'>
      <Box bgcolor={COLORS.white} minHeight='100vh'>
        <Skeleton height={unit(71)} variant='rectangular' />
        <Stack
          gap={unit(3)}
          paddingTop={unit(7)}
          paddingRight={unit(9.5)}
          paddingBottom={unit(6)}
          paddingLeft={unit(7.75)}
        >
          <Skeleton width='80%' height={unit(9.5)} variant='rectangular' />
          <Skeleton width={unit(35)} height={unit(6)} />
        </Stack>
        <Stack gap={unit(4)} paddingX={unit(2.75)}>
          <Stack bgcolor={COLORS.hiekka[500]} paddingX={unit(1.75)} marginBottom={unit(1.75)}>
            <Skeleton width={unit(20)} height={unit(9)} sx={{ marginTop: unit(6), marginBottom: unit(2) }} />
            <Stack bgcolor={COLORS.vaalea['60%']}>
              <WeekPreviewLoading />
              <Divider sx={{ borderColor: COLORS.hiekka[500] }} />
              <WeekPreviewLoading />
              <Divider sx={{ borderColor: COLORS.hiekka[500] }} />
              <WeekPreviewLoading />
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </LayoutNavigationBack>
  )
}
